import React from "react";

export function StatCard({ label, value, sub, icon: Icon, accent }) {
  return (
    <div className="premium-card p-4">
      <div className="flex items-center justify-between">
        <div className="text-[11px] uppercase tracking-wide font-semibold text-[hsl(var(--muted-foreground))]">{label}</div>
        {Icon && (
          <div className={`flex h-8 w-8 items-center justify-center rounded-lg ${accent === "gold" ? "bg-[hsl(var(--pc-gold)/0.15)] text-[hsl(var(--pc-gold))]" : "bg-[hsl(var(--secondary)/0.12)] text-[hsl(var(--secondary))]"}`}>
            <Icon className="h-4 w-4" />
          </div>
        )}
      </div>
      <div className="font-serif text-3xl text-[hsl(var(--primary))] mt-2">{value}</div>
      {sub && <div className="text-xs text-[hsl(var(--muted-foreground))] mt-0.5">{sub}</div>}
    </div>
  );
}

export function PageIntro({ children }) {
  return <p className="text-sm text-[hsl(var(--muted-foreground))] mb-5 max-w-2xl">{children}</p>;
}

export function PlaceholderState({ icon: Icon, title, description, badge }) {
  return (
    <div className="premium-card p-10 text-center">
      {badge && <div className="gold-chip mx-auto mb-4">{badge}</div>}
      {Icon && (
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-[hsl(var(--secondary)/0.12)] text-[hsl(var(--secondary))] mb-4">
          <Icon className="h-7 w-7" />
        </div>
      )}
      <h3 className="font-serif text-2xl text-[hsl(var(--primary))]">{title}</h3>
      <p className="text-sm text-[hsl(var(--muted-foreground))] mt-2 max-w-md mx-auto">{description}</p>
    </div>
  );
}

export function Card({ children, className = "" }) {
  return <div className={`premium-card p-5 ${className}`}>{children}</div>;
}
